import React, { Component, createRef } from 'react';

// CSS
import './Meetings.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch } from '../../Helper/Api';
import { loadMeetingRoom } from '../../Helper/meetingScripts';

// Components
import Header from '../../components/Header/Header';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

// The teacher inside a live meeting: opens the room (POST /meetings/{id}/start) and hands it to the shared room UI.
class MeetingLive extends Component {
    constructor(props) {
        super(props);
        this.box = createRef(null);
        this.handle = null;
    }

    state = { error: null }

    componentDidMount() {
        document.title = properties.site_name + ' | ميتنج مباشر';
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        const id = this.props.match.params.id;
        Promise.all([loadMeetingRoom(), apiFetch(`/meetings/${id}/start`, { method: 'POST' })])
            .then(([Room, info]) => {
                if (!this.box.current) return;
                this.handle = Room.mount(this.box.current, info, {
                    onEnd: () => apiFetch(`/meetings/${id}`, { method: 'DELETE' }).then(() => { window.location.href = '/meetings'; }),
                    onLeave: () => { window.location.href = '/meetings'; },
                    // let a student speak / take the floor back / remove or ban (MeetingController)
                    // chat kept on the server (history for late joiners, and the lock state)
                    chat: {
                        history: (after) => apiFetch(`/meetings/${id}/chat`, { query: after ? { after } : undefined }),
                        send: (text, clientId) => apiFetch(`/meetings/${id}/chat`, { method: 'POST', body: { text, clientId } }),
                        setLocked: (locked) => apiFetch(`/meetings/${id}/chat-lock`, { method: 'PUT', body: { locked } }),
                    },
                    // recording into the course (MeetingRecordingService)
                    recording: {
                        start: () => apiFetch(`/meetings/${id}/recording/start`, { method: 'POST' }),
                        stop: () => apiFetch(`/meetings/${id}/recording/stop`, { method: 'POST' }),
                    },
                    // polls and quick questions (MeetingPollService)
                    polls: {
                        list: () => apiFetch(`/meetings/${id}/polls`),
                        create: (body) => apiFetch(`/meetings/${id}/polls`, { method: 'POST', body }),
                        close: (pollId) => apiFetch(`/meetings/${id}/polls/${pollId}/close`, { method: 'POST' }),
                        share: (pollId, shared) => apiFetch(`/meetings/${id}/polls/${pollId}/shared`, { method: 'PUT', body: { shared } }),
                    },
                    moderate: (identity, action, body) => {
                        const base = `/meetings/${id}/participants/${encodeURIComponent(identity)}`;
                        if (action === 'speak') return apiFetch(base + '/speak', { method: 'POST', body: body || {} });
                        if (action === 'silence') return apiFetch(base + '/speak', { method: 'DELETE' });
                        return apiFetch(base + '/remove', { method: 'POST', body: body || {} });
                    },
                });
            })
            .catch(e => this.setState({ error: e.message || String(e) }));
        window.addEventListener('beforeunload', this.warn);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.warn);
        if (this.handle) this.handle.leave();
    }

    // leaving the page drops the teacher out of the room (the meeting keeps running and they can rejoin)
    warn = (e) => {
        e.preventDefault();
        e.returnValue = '';
    }

    render() {
        return (
            <>
                <Header pageName="ميتنج مباشر" />
                <div className="content meetings-page" dir="rtl">
                    <div className="container mt-live">
                        <div className="mt-top">
                            <Button label="رجوع للميتنجات" icon="pi pi-arrow-right" className="p-button-text" onClick={() => { window.location.href = '/meetings'; }} />
                            <a className="p-button p-button-outlined p-button-sm" href={`/meetings/${this.props.match.params.id}/attendance`} target="_blank" rel="noopener noreferrer">
                                <i className="pi pi-users" />&nbsp;الحضور</a>
                        </div>
                        {this.state.error && (
                            <div className="mt-error-box">
                                <p className="mt-error">{this.state.error}</p>
                                {/رصيد/.test(this.state.error) && <Button label="اشحن محفظتك" icon="pi pi-wallet" onClick={() => { window.location.href = '/billing'; }} />}
                            </div>
                        )}
                        <div ref={this.box} className="mt-room" />
                    </div>
                </div>
            </>
        );
    }
}

export default MeetingLive;
